import React, { useState } from 'react'
import { FiEdit3, FiTrash2, FiUserCheck } from 'react-icons/fi';
import whatsapp_img from '../../../Images/whatsapp.png'
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { useUpdateStatus } from '../Modal/EditUserDetails/hook';
import ResponsiveRows from '../../../components/ResponsiveRows';



const ClientTable = ({ alluserList, open, userRole }) => {

    const navigate = useNavigate()
    const goToDetails = (id) => {
        navigate(`/operational-user/${id}`)
    }

    const [userId, setUserId] = useState("")

    const { deleteUser } = useUpdateStatus()

    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false)
    }

    const handleShow = (id) => {
        setUserId(id)
        setShow(true);
    }

    const handleSubmit = ()=>{
        deleteUser(userId)
        handleClose()
    }

    

    return (

        <>

            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Delete User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span style={{ fontSize: 18 }}>
                        Do you want to delete this user
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={handleSubmit}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            <ResponsiveRows
                rows={alluserList || []}
                getRowId={(user) => user._id}
                resetKey={userRole}
                renderSummary={(user) => <><strong>{user.username}</strong><span>{user.role} · {user.active ? 'Active' : 'Inactive'}</span></>}
                renderDetails={(user) => (
                    <dl>
                        <div><dt>Phone</dt><dd>{user.mobile || '-'}</dd></div>
                        <div><dt>Role</dt><dd>{user.role}</dd></div>
                        <div><dt>Status</dt><dd>{user.active ? 'Active' : 'Inactive'}</dd></div>
                        {userRole === 'client' && <div><dt>WhatsApp integration</dt><dd>{user.whatsapp_integration ? 'Enabled' : '-'}</dd></div>}
                        <div><dt>Actions</dt><dd className="responsive-row-actions">
                            {userRole === 'operational' && <button type="button" className="shortlinks-copy" title={`Assign clients to ${user.username}`} aria-label={`Assign clients to ${user.username}`} onClick={() => goToDetails(user._id)}><FiUserCheck size={18} /></button>}
                            <button type="button" className="shortlinks-copy" title={`Edit ${user.username}`} aria-label={`Edit ${user.username}`} onClick={() => open(user._id)}><FiEdit3 size={17} /></button>
                            <button type="button" className="shortlinks-copy user-delete" title={`Delete ${user.username}`} aria-label={`Delete ${user.username}`} onClick={() => handleShow(user._id)}><FiTrash2 size={17} /></button>
                        </dd></div>
                    </dl>
                )}
            >
            <table className="shortlinks-table users-table">
                <thead>

                    <tr>
                        <th width="10%">No</th>
                        <th width="20%">User Name </th>
                        <th>Phone No</th>
                        <th>Role</th>
                        {
                            userRole === "client" &&
                            <th style={{ textAlign: 'center' }}>Whatsapp Integration</th>
                        }

                        {
                            userRole === "operational"
                            &&
                            <>
                                <th style={{ textAlign: 'center' }}>Assign Clients</th>
                                {/* <th style={{ textAlign: 'center' }}>View</th> */}
                            </>

                        }
                        <th style={{ textAlign: 'center' }}>Status</th>
                        {
                            <th style={{ textAlign: 'center' }}>Edit</th>
                        }

                        <th style={{ textAlign: 'center' }}>Delete</th>
                    </tr>

                </thead>
                <tbody >

                    {
                        alluserList !== null && alluserList.length > 0 ? alluserList.map((item, index) => {
                            const { _id, username, role, mobile, active, whatsapp_integration } = item
                            return (
                                <tr key={_id}>
                                    <td>{index + 1}</td>
                                    <td>{username}</td>
                                    <td>{mobile}</td>
                                    <td>{role}</td>
                                    {
                                        userRole === "client" &&
                                        <td align='center'>
                                            {
                                                whatsapp_integration
                                                    ?
                                                    <img src={whatsapp_img} alt='whatsapp_icon' style={{ width: 25, height: 25 }} />
                                                    :
                                                    "-"
                                            }
                                        </td>
                                    }

                                    {
                                        userRole === "operational"
                                        &&
                                        <>
                                            <td align='center' >
                                                {/* <MdAssignmentTurnedIn size={20} onClick={() => { handleShowAssignModel(_id) }} /> */}
                                                <button type="button" className="shortlinks-copy" title={`Assign clients to ${username}`} aria-label={`Assign clients to ${username}`} onClick={() => goToDetails(_id)}><FiUserCheck size={18} /></button>
                                            </td>
                                            {/* <td align='center' >
                                            <label className='btn-edit' onClick={() => { handleShowOperationalUnderClients(_id) }}>
                                                View
                                            </label>
                                        </td> */}
                                        </>
                                    }
                                    <td align='center'>
                                        <span className={`user-status${active ? ' is-active' : ''}`}>{active ? "Active" : 'Inactive'}</span>

                                    </td>
                                    {
                                        <td align='center'>
                                            <button type="button" className="shortlinks-copy" title={`Edit ${username}`} aria-label={`Edit ${username}`} onClick={() => open(_id)}><FiEdit3 size={17} /></button>
                                        </td>
                                    }

                                    <td align='center'>
                                        <button type="button" className="shortlinks-copy user-delete" title={`Delete ${username}`} aria-label={`Delete ${username}`} onClick={() => handleShow(_id)}><FiTrash2 size={17} /></button>
                                    </td>
                                </tr>
                            )
                        })
                            :
                            <tr>
                                <td colSpan="8" className="shortlinks-table-message">{userRole === 'client' ? 'No clients found.' : 'No operationals found.'}</td>

                            </tr>
                    }
                </tbody>
            </table>
            </ResponsiveRows>
        </>
    )
}

export default ClientTable